var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBxWalletPurple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 10H15.0007V13.3333H13.334V10Z",
    fill: "#492897"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.666 5.83333V4.16667C16.666 3.2475 15.9185 2.5 14.9993 2.5H4.16602C2.78768 2.5 1.66602 3.62167 1.66602 5V15C1.66602 16.8342 3.16102 17.5 4.16602 17.5H16.666C17.5852 17.5 18.3327 16.7525 18.3327 15.8333V7.5C18.3327 6.58083 17.5852 5.83333 16.666 5.83333ZM4.16602 4.16667H14.9993V5.83333H4.16602C3.95145 5.82374 3.74885 5.73174 3.60041 5.57651C3.45197 5.42129 3.36913 5.21478 3.36913 5C3.36913 4.78522 3.45197 4.57871 3.60041 4.42349C3.74885 4.26826 3.95145 4.17626 4.16602 4.16667ZM16.666 15.8333H4.17602C3.79102 15.8233 3.33268 15.6708 3.33268 15V7.34583C3.59435 7.44 3.87185 7.5 4.16602 7.5H16.666V15.8333Z",
    fill: "#492897"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxWalletPurple);
export default __webpack_public_path__ + "static/media/bx_wallet_purple.0c70b22bae42d4f5ed9b049b26dd08d5.svg";
export { ForwardRef as ReactComponent };